import script from "./OptionPill.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionPill.vue?vue&type=script&setup=true&lang=js"

import "./OptionPill.vue?vue&type=style&index=0&id=7faf204a&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7faf204a"]])

export default __exports__